export const RouteUrls = {
  home: '/',
  aboutUs: '/about-us',
  successStories: '/success-stories',
  ourServices: '/our-services',
  contactUs: '/contact-us'
};